import { a11yProps } from "../../Utils/TabsAllyProps";

export const TechnologicalFeaturesFinepTabs = [
    {
        label: "Informações Gerais",
        props: a11yProps(0)
    },
    {
        label: "Atuação da Empresa",
        props: a11yProps(1)
    },
    {
        label: "Histórico de Inovação",
        props: a11yProps(2)
    },
    {
        label: "Características das Atividades Inovativas",
        props: a11yProps(3)
    }
]